import { SPACE_UNIT_SIZE_PX } from "src/theme";
import { avatarSizeMap } from "src/theme/components/avatar";
import { buildImageSources, getImageBaseUrl, IImageSources } from "src/utils/responsive-image-util";

const defaultColor = "gray.800";

const colorMap = new Map([
    [0, defaultColor],
    [1, "green.600"],
    [2, "sky.600"],
    [3, "teal.600"],
    [4, "lilac.600"],
    [5, "orange.600"],
    [6, "blush.600"],
    [7, "blue.600"],
]);

export const getAvatarColor = (id: string) => {
    const unicodeSum = id.split("").reduce((acc, curr) => acc + curr.charCodeAt(0), 0);
    return colorMap.get(unicodeSum % colorMap.size) || defaultColor;
};

export type IAvatarSizeToken = keyof typeof avatarSizeMap;

export const getAvatarPixelSize = (size: IAvatarSizeToken | IAvatarSizeToken[]) => {
    const sizes = typeof size === "string" ? [size] : size;
    return Math.max(...sizes.map(value => avatarSizeMap[value])) * SPACE_UNIT_SIZE_PX;
};

export const getTraderAvatarSources = (traderId: string, pixelSize: number): IImageSources =>
    buildImageSources({ baseUrl: `${getImageBaseUrl()}images/top-trader/${traderId}_profile.png`, queryParams: { w: pixelSize, h: pixelSize } });
